import { Form } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import React from 'react';

export default class StepTwo extends React.Component {
    renderContingent(contingent) {
        return (
            <Form.Radio
                key={contingent.uuid}
                checked={this.props.selectedContingent === contingent}
                onChange={() => this.props.selectContingent(contingent)}
                label={contingent.name}
            />
        );
    }

    /*
     * Find the contingents from rates
     * Rates contain the inventories, so we find if the current exits in them.
     * Rates, and RateTemplates associated to them,
     * contain the contingents, so we keep them in the accumulator and retun them
     * @return {array} - The contingent(s) contained in the rates.
     */
    foundContingentsFromInventory() {
        const { currentInventory, rate: stateRate } = this.props;
        if (!stateRate || (stateRate && !stateRate.rates)) {
            return [];
        }

        // Find categories in the seat selected
        let categories = this.props.seats.reduce((accumulator, seat) => {
            // WARNING seat object is here seatlib model and not a Willy model...
            if (!accumulator.includes(seat.category)) {
                accumulator.push(seat.category);
            }
            return accumulator;
        }, []);

        return stateRate.rates.reduce((accumulator, rate) => {
            // Category does not match neither rate nor rate_template

            if (!categories.includes(rate.resolved_category)) {
                return accumulator;
            }

            // eslint-disable-line react/prop-types
            // The rate is available in the current inventory
            if (rate.inventories.includes(currentInventory.uuid)) {
                // eslint-disable-line react/prop-types
                // The contingents includes in the rate are keep once
                rate.resolved_contingents.forEach(contingentID => {
                    // eslint-disable-line react/prop-types
                    if (!accumulator.includes(contingentID)) {
                        accumulator.push(contingentID);
                    }
                });
            }
            return accumulator;
        }, []);
    }

    /**
     * Filter the contingents with no rates or with rates that contain currentInventory
     * @return {Array} - The contingents to display
     */
    filterContingents() {
        const { contingents } = this.props;
        const contingentsFromInventory = this.foundContingentsFromInventory();

        return contingents
            .reduce((accumulator, contingent) => {
                // If the contingent has no rates
                // If the contingent has a minima one rate in the inventory
                if (!contingent.rates?.length || contingentsFromInventory.includes(contingent.uuid)) {
                    accumulator.push(contingent);
                }

                return accumulator;
            }, [])
            .sort((one, another) => (one.name < another.name ? -1 : 1))
            .map(contingent => this.renderContingent(contingent));
    }

    render() {
        // Find the contingents to display
        const contingents = this.filterContingents();

        return (
            <div className="contingents">
                <Form.Group>{contingents}</Form.Group>
            </div>
        );
    }
}

StepTwo.propTypes = {
    contingents: PropTypes.object.isRequired,
    currentInventory: PropTypes.object.isRequired,
    rate: PropTypes.shape({
        rates: PropTypes.array,
        ratesByContingents: PropTypes.object,
        inventories: PropTypes.array,
        category: PropTypes.object,
        contingents: PropTypes.array,
        rate_template: PropTypes.object
    }).isRequired,
    seats: PropTypes.array.isRequired,
    selectContingent: PropTypes.func.isRequired,
    selectedContingent: PropTypes.object.isRequired,
    zone: PropTypes.object.isRequired
};
